export default __webpack_public_path__ + "static/media/base-4-min.c68385e0.jpg";